import React, { ButtonHTMLAttributes } from "react";
import { BtnLoader } from "../../../icons";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "success" | "danger" | "disabled";
  size?: "small" | "medium" | "large";
  isSubmitting?: boolean;
  customClasses?: string;
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "medium",
  isSubmitting = false,
  disabled = false,
  customClasses,
  children,
  onClick,
  ...props
}) => {
  const baseStyles =
    "inline-flex items-center justify-center cursor-pointer rounded-full py-1 relative";

  const variantStyles: any = {
    primary: `text-white ${!isSubmitting ? "bg-secondary-300 hover:bg-blue-600" : "bg-primary-600"}`,
    secondary:
      "text-secondary-300 bg-white border border-secondary-300 hover:bg-secondary-300 hover:text-white",
    success: "text-white bg-green-500 hover:bg-green-600",
    danger: "text-white bg-red-500 hover:bg-red-600",
    disabled: "bg-[#ebebeb] hover:cursor-not-allowed",
  };

  const sizeStyles = {
    small: "px-3 py-1.5 text-sm",
    medium: "px-4 py-2 text-base",
    large: "px-5 py-3 text-lg",
  };

  return (
    <button
      className={`
        ${baseStyles} ${customClasses} ${variantStyles[variant]} ${sizeStyles[size]}
        `}
      disabled={isSubmitting || disabled}
      onClick={onClick}
      {...props}
    >
      <>
        <div
          className={`absolute top-2/4 left-2/4 transform -translate-x-1/2 -translate-y-1/2 ${isSubmitting ? "opacity-1" : "opacity-0"}`}
        >
          <BtnLoader />
        </div>
        <div className={`${isSubmitting ? "opacity-0" : "opacity-1"}`}>
          {children}
        </div>
      </>
    </button>
  );
};

export default Button;
